import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

const authToken = localStorage.getItem("auth_token");

window.Echo = new Echo({
  broadcaster: "pusher",
  key: "14a3ffe8d5d4bfb2c19a",
  cluster: "mt1",
  forceTLS: true,
  encrypted: true,
  authEndpoint: "https://loopsneller.com/broadcasting/auth",
  auth: {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  },
});
